import React, { Component } from 'react';

import './Logo.css';
import { exhibitStoreId, getLogoDataAsync } from '../../utils/StoreConfigManager.js';
import { LogoClicked } from '../../utils/Analytics.js';
import { constructUrl } from '../../utils/UrlConstructor.js';
import InteractableElement from './InteractableElement';
import BaseImage from './image-components/BaseImage';
import { getStoreId } from '../../utils/StoreConfigManager.js';
import { isMobileDevice } from '../../utils/DeviceDetector';

const popUpStore= '614152899ed97ea76b0905de'
const storeId = getStoreId()
const isMobile = isMobileDevice()
const style = {
    width: storeId=== exhibitStoreId ? '25%' : '60%',
};
class Logo extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.state = {
            imageSrc: '',
            redirectUrl: ''
        };
        getLogoDataAsync()
            .then((logoData) => {
                const imageSrcObject = logoData['imageSrc'];
                const redirectUrlObject = logoData['redirectUrl'];
                const imageSrc = imageSrcObject ? constructUrl(imageSrcObject) : '';
                const redirectUrl = redirectUrlObject ? constructUrl(redirectUrlObject) : '';

                this.setState({
                    imageSrc: imageSrc,
                    redirectUrl: redirectUrl
                });
            })
            .catch(error => console.error(error));
    }

    onClick() {
        LogoClicked();
        window.open(this.state.redirectUrl, '_blank');
    }

    render() {
        const imageSrc = this.state.imageSrc;
        if (!imageSrc) {
            return <React.Fragment />
        }
        return (
            <div id='topLeftLogo' className='hoverable' style={{"width": (popUpStore === storeId ) && (isMobile ? "40%" : "10%")}}>
                <InteractableElement
                    onClick={this.onClick}
                >
                    <BaseImage
                        src={imageSrc}
                        style={style}
                    />
                </InteractableElement>
            </div>
        );
    }
}

export default Logo;
